import React from "react";

/**
 * 卡片型自定义消息的基础布局。
 * 所有继承此基类的消息只需传入 props，无需重复写卡片骨架。
 *
 * @param {string}   tagColor   - 标签背景色
 * @param {string}   tagText    - 标签文字（活动/攻略/交易…）
 * @param {string}   title      - 标签旁标题文字
 * @param {object}   gameInfo   - attach.game_info（游戏名 + 头图）
 * @param {string}   desc       - 正文摘要
 * @param {string}   descClass  - 摘要行数限制 class（"imc-line2" / "imc-line3" / ""）
 * @param {function} onClick    - 整卡点击事件
 * @param {node}     children   - 注入到摘要下方的额外内容（如价格行）
 */
export default function CustomCardBase({
  tagColor,
  tagText,
  title,
  gameInfo,
  desc,
  descClass = "",
  onClick,
  children,
}) {
  return (
    <div className="imc-card" onClick={onClick}>
      <div className="imc-card-head">
        <span className="imc-card-tag" style={{ backgroundColor: tagColor }}>{tagText}</span>
        <span className="imc-card-tag-title" style={{ color: tagColor }}>{title}</span>
      </div>
      <div className="imc-card-body">
        <div className="imc-card-content">
          <div className="imc-card-gamename">
            {gameInfo?.game_name}
            {gameInfo?.nameRemark ? "-" + gameInfo.nameRemark : ""}
          </div>
          {desc != null && (
            <div className={`imc-card-desc ${descClass}`.trim()}>{desc}</div>
          )}
          {children}
        </div>
        <img height={63} src={gameInfo?.game_image?.thumb} alt="" className="imc-card-thumb" />
      </div>
    </div>
  );
}
